import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, extends as _extends, toConsumableArray as _toConsumableArray } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useRef, useEffect } from 'react';
import { FormInputOptionGroup, FormItem, FormLabel } from '@tesla/design-system-react';
import { Option } from './Option.js';
import { FeedBack } from './Feedback.js';
import { utils, useField } from 'informed';
import { OptionGroupContext } from './context.js';

var _excluded = ["children", "alternate", "multiselect", "className", "noFormItem"],
  _excluded2 = ["onChange", "value"];
var OptionGroup = function OptionGroup(_ref) {
  var children = _ref.children;
    _ref.alternate;
    var userMultiselect = _ref.multiselect,
    className = _ref.className,
    noFormItem = _ref.noFormItem,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(function () {
      return utils.uuidv4();
    }),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var wrapperRef = useRef();
  var _useField = useField(props),
    informed = _useField.informed,
    fieldApi = _useField.fieldApi,
    fieldState = _useField.fieldState,
    userProps = _useField.userProps;
    _useField.ref;
  var label = userProps.label,
    options = userProps.options;
    userProps.required;
    var multiple = userProps.multiple,
    feedback = userProps.feedback,
    helper = userProps.helper;
    userProps.caption;
    userProps.tooltip;
    var layout = userProps.layout;
  var showError = fieldState.showError,
    error = fieldState.error;
  var multiselect = userMultiselect !== null && userMultiselect !== void 0 ? userMultiselect : multiple;
  var onChange = function onChange(e) {
    if (multiselect) {
      // Get current array
      var curValue = fieldApi.getValue() || [];
      // Get the change value
      var changeValue = e.target.value;
      // See if its already in array
      if (curValue.includes(changeValue)) {
        // If it does take it out
        var newVal = curValue.filter(function (v) {
          return v != changeValue;
        });
        // Set val
        fieldApi.setValue(newVal, e);
      } else {
        // Its not in yet so add!
        var _newVal = [].concat(_toConsumableArray(curValue), [changeValue]);
        // Set val
        fieldApi.setValue(_newVal, e);
      }
    } else {
      fieldApi.setValue(e.target.value, e);
    }
  };

  // Take off on change and value
  informed.onChange;
    var value = informed.value,
    rest = _objectWithoutProperties(informed, _excluded2);
  var context = {
    optionGroupHandler: _objectSpread2({
      onChange: onChange
    }, rest),
    optionGroupContext: _objectSpread2(_objectSpread2({
      name: userProps.name,
      multiselect: multiselect
    }, fieldState), {}, {
      id: id,
      disabled: userProps.disabled
    })
  };

  // Scroll to initial if there is a value
  useEffect(function () {
    if (!noFormItem && wrapperRef.current && value) {
      // Find the container with horizontal scroll within wrapperRef
      var scrollContainer = wrapperRef.current.querySelector('.tds-form-input-group');
      if (scrollContainer) {
        var checkedInput = scrollContainer.querySelector('input:checked');
        if (checkedInput) {
          // Get the bounding rectangle of the input and the scroll container
          var inputRect = checkedInput.getBoundingClientRect();
          var containerRect = scrollContainer.getBoundingClientRect();

          // Calculate the input's position relative to the scroll container
          var relativeInputLeft = inputRect.left - containerRect.left + scrollContainer.scrollLeft;

          // Adjust scrollContainer's scrollLeft to bring the checked input into view
          scrollContainer.scrollLeft = relativeInputLeft - 20; // Adjusting for any padding/margin if necessary
        }
      }
    }
  }, []);
  if (noFormItem) {
    return /*#__PURE__*/React.createElement(OptionGroupContext.Provider, {
      value: context
    }, /*#__PURE__*/React.createElement(FormInputOptionGroup, {
      showVisualCheckbox: multiselect,
      className: className
    }, children ? children : options.map(function (option) {
      return /*#__PURE__*/React.createElement(Option, _extends({
        key: "".concat(id, "-").concat(option.value)
      }, option));
    })));
  }
  return /*#__PURE__*/React.createElement(OptionGroupContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(FormItem, {
    variant: "selector",
    error: showError,
    wrapperRef: wrapperRef
  }, label ? /*#__PURE__*/React.createElement(FormLabel, null, label) : null, /*#__PURE__*/React.createElement(FormInputOptionGroup, {
    showVisualCheckbox: multiselect,
    className: className,
    layout: layout
  }, children ? children : options.map(function (option) {
    return /*#__PURE__*/React.createElement(Option, _extends({
      key: "".concat(id, "-").concat(option.value)
    }, option));
  })), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError
  })));
};

export { OptionGroup };
